module.exports = __webpack_public_path__ + "img/ca.12792c8.png";